/*
**  rui-percentage-circle.js
**
**  rui-percentage-circle component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
export class RuiPercentageCircle extends LitElement {
    static get is() {
        return 'rui-percentage-circle';
    }
    static get properties() {
        return {
            text: { type: String },
            value: { type: Number },
            size: { type: String }
        };
    }
    constructor() {
        super();
        this.text = '';
        this.value = 0;
        this.size = 'medium';
    }
    render() {
        const size = this.size ? this.size.toLowerCase() : 'medium';
        let value = Math.min(Math.max(this.value, 0), 100);
        const classes = {
            ['rui-percentage-circle']: true,
            ['rui-percentage-circle-center']: true,
            ['rui-percentage-circle-percent-' + value]: true,
            ['rui-percentage-circle-large']: size === 'large',
            ['rui-percentage-circle-small']: size === 'small'
        };
        return html `
            <div class="${classMap(classes)}" aria-valuemin="0" aria-valuemax="100" attr.aria-valuenow="${this.value}">
                <span>${this.text}</span>
                <div class="rui-percentage-circle-slice">
                    <div class="rui-percentage-circle-bar"></div>
                    <div class="rui-percentage-circle-fill"></div>
                </div>
            </div>
        `;
    }
    static get styles() {
        return css `
            .rui-percentage-circle > span {
                color: var(--text-regular, #181830);
            }
            
            .rui-percentage-circle:after {
                background-color: var(--percentage-circle-data-bg, #f4f4f4);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-slice,
            .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-slice, .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-slice {
                clip: rect(auto, auto, auto, auto);
            }
            
            .rui-percentage-circle .rui-percentage-circle-bar,
            .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-fill {
                position: absolute;
                border: 0.08em solid var(--percentage-circle-data-active, #3878ab);
                width: 0.84em;
                height: 0.84em;
                clip: rect(0em, 0.5em, 1em, 0em);
                border-radius: 50%;
                transform: rotate(0deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-fill,
            .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-bar:after, .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-fill {
                transform: rotate(180deg);
            }
            
            .rui-percentage-circle {
                background-color: var(--percentage-circle-data-inactive, #ccc);
                position: relative;
                font-size: 120px;
                width: 1em;
                height: 1em;
                border-radius: 50%;
                float: left;
                margin: 0 0.1em 0.1em 0;
            }
            
            @media print {
                .rui-percentage-circle {
                    background-color: #dddddd;
                    border-color: #000000;
                }
            
                .rui-percentage-circle > span {
                    color: #000000;
                }
                
                .rui-percentage-circle:after {
                    background-color: #ffffff;
                }

                .rui-percentage-circle .rui-percentage-circle-bar,
                .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-fill,
                .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-fill, .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-fill {
                    border-color: #000000;
                }
            }
            
            .rui-percentage-circle *, .rui-percentage-circle *:before, .rui-percentage-circle *:after {
                box-sizing: content-box;
            }
            
            .rui-percentage-circle.rui-percentage-circle-center {
                float: none;
                margin: 0 auto;
            }
            
            .rui-percentage-circle.rui-percentage-circle-large {
                font-size: 240px;
            }
            
            .rui-percentage-circle.rui-percentage-circle-small {
                font-size: 80px;
            }
            
            .rui-percentage-circle > span {
                position: absolute;
                width: 100%;
                z-index: 1;
                left: 0;
                top: 0;
                width: 5em;
                line-height: 5em;
                font-size: 0.2em;
                display: block;
                text-align: center;
                white-space: nowrap;
                transition-property: all;
                transition-duration: 0.2s;
                transition-timing-function: ease-out;
            }
            
            .rui-percentage-circle:after {
                position: absolute;
                top: 0.08em;
                left: 0.08em;
                display: block;
                content: " ";
                border-radius: 50%;
                width: 0.84em;
                height: 0.84em;
                transition-property: all;
                transition-duration: 0.2s;
                transition-timing-function: ease-in;
            }
            
            .rui-percentage-circle .rui-percentage-circle-slice {
                position: absolute;
                width: 1em;
                height: 1em;
                clip: rect(0em, 1em, 1em, 0.5em);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-1 .rui-percentage-circle-bar {
                transform: rotate(3.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-2 .rui-percentage-circle-bar {
                transform: rotate(7.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-3 .rui-percentage-circle-bar {
                transform: rotate(10.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-4 .rui-percentage-circle-bar {
                transform: rotate(14.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-5 .rui-percentage-circle-bar {
                transform: rotate(18deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-6 .rui-percentage-circle-bar {
                transform: rotate(21.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-7 .rui-percentage-circle-bar {
                transform: rotate(25.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-8 .rui-percentage-circle-bar {
                transform: rotate(28.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-9 .rui-percentage-circle-bar {
                transform: rotate(32.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-10 .rui-percentage-circle-bar {
                transform: rotate(36deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-11 .rui-percentage-circle-bar {
                transform: rotate(39.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-12 .rui-percentage-circle-bar {
                transform: rotate(43.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-13 .rui-percentage-circle-bar {
                transform: rotate(46.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-14 .rui-percentage-circle-bar {
                transform: rotate(50.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-15 .rui-percentage-circle-bar {
                transform: rotate(54deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-16 .rui-percentage-circle-bar {
                transform: rotate(57.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-17 .rui-percentage-circle-bar {
                transform: rotate(61.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-18 .rui-percentage-circle-bar {
                transform: rotate(64.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-19 .rui-percentage-circle-bar {
                transform: rotate(68.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-20 .rui-percentage-circle-bar {
                transform: rotate(72deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-21 .rui-percentage-circle-bar {
                transform: rotate(75.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-22 .rui-percentage-circle-bar {
                transform: rotate(79.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-23 .rui-percentage-circle-bar {
                transform: rotate(82.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-24 .rui-percentage-circle-bar {
                transform: rotate(86.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-25 .rui-percentage-circle-bar {
                transform: rotate(90deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-26 .rui-percentage-circle-bar {
                transform: rotate(93.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-27 .rui-percentage-circle-bar {
                transform: rotate(97.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-28 .rui-percentage-circle-bar {
                transform: rotate(100.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-29 .rui-percentage-circle-bar {
                transform: rotate(104.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-30 .rui-percentage-circle-bar {
                transform: rotate(108deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-31 .rui-percentage-circle-bar {
                transform: rotate(111.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-32 .rui-percentage-circle-bar {
                transform: rotate(115.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-33 .rui-percentage-circle-bar {
                transform: rotate(118.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-34 .rui-percentage-circle-bar {
                transform: rotate(122.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-35 .rui-percentage-circle-bar {
                transform: rotate(126deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-36 .rui-percentage-circle-bar {
                transform: rotate(129.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-37 .rui-percentage-circle-bar {
                transform: rotate(133.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-38 .rui-percentage-circle-bar {
                transform: rotate(136.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-39 .rui-percentage-circle-bar {
                transform: rotate(140.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-40 .rui-percentage-circle-bar {
                transform: rotate(144deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-41 .rui-percentage-circle-bar {
                transform: rotate(147.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-42 .rui-percentage-circle-bar {
                transform: rotate(151.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-43 .rui-percentage-circle-bar {
                transform: rotate(154.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-44 .rui-percentage-circle-bar {
                transform: rotate(158.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-45 .rui-percentage-circle-bar {
                transform: rotate(162deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-46 .rui-percentage-circle-bar {
                transform: rotate(165.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-47 .rui-percentage-circle-bar {
                transform: rotate(169.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-48 .rui-percentage-circle-bar {
                transform: rotate(172.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-49 .rui-percentage-circle-bar {
                transform: rotate(176.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-50 .rui-percentage-circle-bar {
                transform: rotate(180deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-51 .rui-percentage-circle-bar {
                transform: rotate(183.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-52 .rui-percentage-circle-bar {
                transform: rotate(187.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-53 .rui-percentage-circle-bar {
                transform: rotate(190.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-54 .rui-percentage-circle-bar {
                transform: rotate(194.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-55 .rui-percentage-circle-bar {
                transform: rotate(198deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-56 .rui-percentage-circle-bar {
                transform: rotate(201.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-57 .rui-percentage-circle-bar {
                transform: rotate(205.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-58 .rui-percentage-circle-bar {
                transform: rotate(208.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-59 .rui-percentage-circle-bar {
                transform: rotate(212.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-60 .rui-percentage-circle-bar {
                transform: rotate(216deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-61 .rui-percentage-circle-bar {
                transform: rotate(219.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-62 .rui-percentage-circle-bar {
                transform: rotate(223.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-63 .rui-percentage-circle-bar {
                transform: rotate(226.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-64 .rui-percentage-circle-bar {
                transform: rotate(230.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-65 .rui-percentage-circle-bar {
                transform: rotate(234deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-66 .rui-percentage-circle-bar {
                transform: rotate(237.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-67 .rui-percentage-circle-bar {
                transform: rotate(241.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-68 .rui-percentage-circle-bar {
                transform: rotate(244.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-69 .rui-percentage-circle-bar {
                transform: rotate(248.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-70 .rui-percentage-circle-bar {
                transform: rotate(252deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-71 .rui-percentage-circle-bar {
                transform: rotate(255.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-72 .rui-percentage-circle-bar {
                transform: rotate(259.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-73 .rui-percentage-circle-bar {
                transform: rotate(262.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-74 .rui-percentage-circle-bar {
                transform: rotate(266.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-75 .rui-percentage-circle-bar {
                transform: rotate(270deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-76 .rui-percentage-circle-bar {
                transform: rotate(273.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-77 .rui-percentage-circle-bar {
                transform: rotate(277.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-78 .rui-percentage-circle-bar {
                transform: rotate(280.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-79 .rui-percentage-circle-bar {
                transform: rotate(284.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-80 .rui-percentage-circle-bar {
                transform: rotate(288deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-81 .rui-percentage-circle-bar {
                transform: rotate(291.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-82 .rui-percentage-circle-bar {
                transform: rotate(295.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-83 .rui-percentage-circle-bar {
                transform: rotate(298.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-84 .rui-percentage-circle-bar {
                transform: rotate(302.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-85 .rui-percentage-circle-bar {
                transform: rotate(306deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-86 .rui-percentage-circle-bar {
                transform: rotate(309.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-87 .rui-percentage-circle-bar {
                transform: rotate(313.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-88 .rui-percentage-circle-bar {
                transform: rotate(316.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-89 .rui-percentage-circle-bar {
                transform: rotate(320.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-90 .rui-percentage-circle-bar {
                transform: rotate(324deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-91 .rui-percentage-circle-bar {
                transform: rotate(327.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-92 .rui-percentage-circle-bar {
                transform: rotate(331.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-93 .rui-percentage-circle-bar {
                transform: rotate(334.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-94 .rui-percentage-circle-bar {
                transform: rotate(338.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-95 .rui-percentage-circle-bar {
                transform: rotate(342deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-96 .rui-percentage-circle-bar {
                transform: rotate(345.6deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-97 .rui-percentage-circle-bar {
                transform: rotate(349.2deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-98 .rui-percentage-circle-bar {
                transform: rotate(352.8deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-99 .rui-percentage-circle-bar {
                transform: rotate(356.4deg);
            }
            
            .rui-percentage-circle.rui-percentage-circle-percent-100 .rui-percentage-circle-bar {
                transform: rotate(360deg);
            }
        `;
    }
}
customElements.get(RuiPercentageCircle.is) || customElements.define(RuiPercentageCircle.is, RuiPercentageCircle);
